import { Component } from '@angular/core';
import { TabComponent } from '../../../../components/tab/tab.component';
import { TabLayoutComponent } from '../../../../components/tab-layout/tab-layout.component';
import { APITableComponent } from '../../../../components/table/api-table/api-table.component';
import { BaseDraftTabComponent } from '../base-draft-tab.component';
import { ButtonDirective } from '../../../../components/button/button.directive';
import { NgIcon } from '@ng-icons/core';
import { ModalComponent } from '../../../../components/modal/modal.component';
import { DraftActionType } from '../../../../interfaces/apis/customer-drafts';

@Component({
  selector: 'app-draft-editing-tab',
  imports: [
    TabLayoutComponent,
    APITableComponent,
    ButtonDirective,
    NgIcon,
    ModalComponent,
  ],
  providers: [{ provide: TabComponent, useExisting: DraftEditingTabComponent }],
  templateUrl: './draft-editing-tab.component.html',
  styleUrl: './draft-editing-tab.component.scss',
})
export class DraftEditingTabComponent extends BaseDraftTabComponent {
  override name = this.dictionaryService.get('Editing');
  readonly draftAction: DraftActionType = 'Editing';
}
